export const gValidStyleChoices = Object.freeze({
  'normal' : {
    text : "Normal Text",
    css : {
      color : "#1C344F",
      fontSize : "14px",
      fontFamily : "Larsseit, Lato, Arial",
      fontWeight : "normal",
    }
  },
  'heading' : {
    text : "HEADER",
    css : {
      color : "1C344F",
      fontSize : "20px",
      fontFamily : "Larsseit, Lato, Arial",
      fontWeight : "bolder"
    }
  },
  'subtext' : {
    text : "SUBTEXT",
    css : {
      color : "#A6A6A6",
      fontSize : "15px",
      fontFamily : "Larsseit, Lato, Arial",
      fontWeight : "lighter"
    }
  }
});
